import type { CmsColor, CmsSeparatorType } from "@/lib/cms/cms-theme.constants";
import { useTranslation } from "react-i18next";
import { CmsTypographyPicker } from "./CmsTypographyPicker";
import { PaletteColorPicker } from "./PaletteColorPicker";
import { SeparatorStyleFields } from "./SeparatorStyleFields";

export type ShellThemeValues = {
  backgroundColorId: string | null;
  textColorId: string | null;
  separatorType: CmsSeparatorType;
  separatorColorId: string | null;
  fontFamily: string | null;
  fontVariant: string | null;
};

type Props = {
  colors: CmsColor[];
  values: ShellThemeValues;
  onChange: (values: ShellThemeValues) => void;
  onColorsChange?: (colors: CmsColor[]) => void;
};

export function ShellThemeFields({
  colors,
  values,
  onChange,
  onColorsChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-6">
      <PaletteColorPicker
        label={t("cms.appearance.background")}
        colors={colors}
        value={values.backgroundColorId}
        onColorsChange={onColorsChange}
        onChange={(backgroundColorId) =>
          onChange({ ...values, backgroundColorId })
        }
      />
      <PaletteColorPicker
        label={t("cms.appearance.textColor")}
        colors={colors}
        value={values.textColorId}
        onColorsChange={onColorsChange}
        onChange={(textColorId) => onChange({ ...values, textColorId })}
      />
      <CmsTypographyPicker
        label={t("cms.typography.shell")}
        value={{
          fontFamily: values.fontFamily,
          fontVariant: values.fontVariant,
        }}
        onChange={({ fontFamily, fontVariant }) =>
          onChange({ ...values, fontFamily, fontVariant })
        }
        allowNone
      />
      <SeparatorStyleFields
        colors={colors}
        onColorsChange={onColorsChange}
        separatorType={values.separatorType}
        separatorColorId={values.separatorColorId}
        onSeparatorTypeChange={(separatorType) =>
          onChange({ ...values, separatorType })
        }
        onSeparatorColorChange={(separatorColorId) =>
          onChange({ ...values, separatorColorId })
        }
      />
    </div>
  );
}
